import { createApi } from '@reduxjs/toolkit/query/react'
import { v4 as uuidv4 } from 'uuid'
import { configManager } from '../../config/configManager'
import { RootState } from '../redux/store'
import { createBaseQueryWithErrorHandling } from './baseQueryWithErrorHandling'

interface TestEmailRequest {
  to: string
  language: string
}

export const mailerApi = createApi({
  reducerPath: 'mailerApi',
  baseQuery: createBaseQueryWithErrorHandling(`${configManager.api.GATEWAY_URL}/mailer`, (headers, { getState }) => {
    headers.set('x-request-id', uuidv4())
    const { token, companyToken } = (getState() as RootState).authReducer
    if (token) {
      headers.set('authorization', `Bearer ${token}`)
    }
    if (companyToken) {
      headers.set('x-company-token', companyToken)
    }
    return headers
  }),
  endpoints: (builder) => ({
    sendTestEmail: builder.mutation<any, TestEmailRequest>({
      query: (data) => ({
        url: '/send-test-email',
        method: 'POST',
        body: data,
      }),
    }),
    testUserSMTP: builder.mutation<any, TestEmailRequest>({
      query: (data) => ({
        url: '/test-user-smtp',
        method: 'POST',
        body: data,
      }),
    }),
  }),
})

export const { useSendTestEmailMutation, useTestUserSMTPMutation } = mailerApi
